import React,{useEffect}  from 'react';
import {
    Form, Button, Select
} from 'antd';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required, FieldSelectNormalEditar,textArea } from '../../app/inputs/InputField';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetCategorias } from '../../../store/acciones/accionesCatalogo';

const Option = Select.Option;


let FormAgregarProducto = props => {
  let categorias = useSelector(state => state.reducerCatalogo.categorias);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(actionGetCategorias());
  }, [dispatch]);


  if (props.data) {
    return (
        <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
            <Field name="titulo" component={InputField} ph="Titulo del producto" validate={[required]} />
            <Field name="descripcion" component={textArea} ph="Descripción" validate={[required]}  />
            <Field name="categorias" component={FieldSelectNormalEditar} ph="Categorias" validate={[required]}  >
                {
                    categorias && categorias.length > 0
                        ? categorias.map((c, key) => (
                            <Option key={c.id} value={c.id}>{c.categoria}</Option>
                        ))
                        : (
                            <Option key={1} value={1} >No existen categorias</Option>
                        )
                }
            </Field>
            <Form.Item>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button loading={props.loading} icon="edit" type="primary" htmlType="submit" className="loginFormButton">
                        Editar
            </Button>
                </div>
            </Form.Item>

        </Form>
    )
      
  } return null
    
  }

const mapStateToProps = (state, props) => {
  return {
    initialValues:{
        titulo:props.data.titulo,
        descripcion:props.data.descripcion,
        categorias:props.data.categorias.id
    }
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 
  }
}
export default connect(mapStateToProps, mapDispatchToProps)( reduxForm({ form: 'FormAgregarProducto' })(FormAgregarProducto))